// Переводы текстов интерфейса: ключ — русский текст
const dict = {
 "Оптовый: {{v0}}": "Bulk: {{v0}}",
 "вес клиента за один приход сверх порога считается по этой цене (если она ниже обычной)": "a client's weight above the threshold in one delivery is charged at this price (if lower than the usual rate)",
 "свыше": "over",
 "кг —": "kg —",
 "Порог, кг за приход": "Threshold, kg per delivery",
 "Оптовый тариф, ₸/кг": "Bulk rate, ₸/kg",
 "свыше {{v0}} кг — {{v1}} ₸/кг": "over {{v0}} kg — {{v1}} ₸/kg",
 "Оптовый тариф филиала сохранён": "Branch bulk rate saved",
 "Оптовый тариф филиала убран": "Branch bulk rate removed",
 "Очерёдность: личный тариф клиента (VIP, в карточке клиента) → тариф филиала → общий. Оптовый тариф действует только на вес сверх порога и только если он ниже обычного тарифа клиента.": "Order: client's personal rate (VIP, in the client card) → branch rate → general. The bulk rate applies only to weight above the threshold and only if it is lower than the client's usual rate.",
 "в т. ч. {{v0}} кг по {{v1}} ₸/кг (оптовый)": "incl. {{v0}} kg at {{v1}} ₸/kg (bulk)",
 "Имя клиента (необязательно)": "Client's first name (optional)",
 "Имя клиента": "Client's first name",
 "Скопировать приглашение": "Copy invitation",
 "Приглашение": "Invite",
 "Забрана курьером": "Picked up by courier",
 "Покинула сортировочный центр": "Left the sorting center",
 "Прибыла на сортировочный центр": "Arrived at the sorting center",
 "Передана курьеру для доставки": "Out for delivery",
 "Принята на складе в Китае": "Received at the warehouse in China",
 "Возврат отправителю": "Returned to sender",
 "Проблема с доставкой": "Delivery problem",
 "В пути по Китаю": "In transit in China",
 " (сегодня)": " (today)",
 " · есть несохранённые изменения": " · there are unsaved changes",
 " · код {{v0}}": " · code {{v0}}",
 " · тариф {{v0}}": " · rate {{v0}}",
 " — не везде задана цена, счета не посчитаются": " — price is not set everywhere, invoices cannot be calculated",
 " — не у всех задана ссылка на оплату": " — not all have a payment link",
 "(Добавлен вручную)": "(Added manually)",
 ", читается именно этот лист.": ", this very sheet is read.",
 "ID филиала:": "Branch ID:",
 "Username (ник из адреса доставки):": "Username (nickname from the delivery address):",
 "Username латиницей": "Username in Latin letters",
 "Username латиницей, например Berik7777": "Username in Latin letters, e.g. Berik7777",
 "WhatsApp номер": "WhatsApp number",
 "username не указан": "username not set",
 "{{v0}} закладок обновлено": "{{v0}} bookmarks updated",
 "{{v0}} закладок удалено": "{{v0}} bookmarks deleted",
 "{{v0}} обновить не удалось": "{{v0}} could not be updated",
 "{{v0}} треков и закладок удалено": "{{v0}} tracks and bookmarks deleted",
 "{{v0}} удалить не удалось": "{{v0}} could not be deleted",
 "{{v0}} ₸/кг": "{{v0}} ₸/kg",
 "{{v0}} ₸/кг ({{v1}})": "{{v0}} ₸/kg ({{v1}})",
 "· вес": "· weight",
 "· всего": "· total",
 "· не задан общий тариф (раздел «Вес»)": "· no general rate set (section “Weight”)",
 "· сумма": "· amount",
 "· тариф": "· rate",
 "· уже выставлено:": "· already invoiced:",
 "» нет на сайте. Проверьте написание. Если человек ещё не зарегистрирован, запись можно сохранить: счёт выставится после его регистрации с таким username.": "» is not on the site. Check the spelling. If the person is not registered yet, the entry can be saved: the invoice will be issued after they register with this username.",
 "Админ панель": "Admin panel",
 "Адрес склада (его видит клиент в разделе «Склад»)": "Warehouse address (shown to the client in the “Warehouse” section)",
 "Адрес филиала:": "Branch address:",
 "Адресс китайского склада": "Chinese warehouse address",
 "Аккаунт": "Account",
 "Аккаунт и пароль": "Account and password",
 "Баллы": "Points",
 "Баннеры": "Banners",
 "Бонусы обновлены": "Bonuses updated",
 "В таблице": "In the table",
 "Ваш сайт": "Your site",
 "Введите ID филиала": "Enter the branch ID",
 "Введите адрес филиала": "Enter the branch address",
 "Введите корректную сумму": "Enter a valid amount",
 "Введите название филиала": "Enter the branch name",
 "Введите новый пароль": "Enter a new password",
 "Введите номер телефона пользователя": "Enter the user's phone number",
 "Введите текст статуса": "Enter the status text",
 "Вес (кг)": "Weight (kg)",
 "Вес, кг": "Weight, kg",
 "Взять текущий текст": "Use current text",
 "Вперёд →": "Next →",
 "Время": "Time",
 "Вручную": "Manually",
 "Все": "All",
 "Все пользователи": "All users",
 "Все поля пустые": "All fields are empty",
 "Все статусы": "All statuses",
 "Все треки": "All tracks",
 "Все уровни": "All levels",
 "Все филиалы": "All branches",
 "Всего треков:": "Total tracks:",
 "Вы уверены, что хотите удалить пользователя?": "Are you sure you want to delete this user?",
 "Вы уверены, что хотите удалить этот филиал?": "Are you sure you want to delete this branch?",
 "Выберите дату": "Choose a date",
 "Выберите дату и статус": "Choose a date and a status",
 "Выберите клиента": "Choose a client",
 "Выберите статус": "Choose a status",
 "Выберите филиал:": "Choose a branch:",
 "Выбрать все в статусе": "Select all in status",
 "Выбрать всё": "Select all",
 "Выбрать статус": "Choose status",
 "Выставить": "Issue",
 "Выставить {{v0}} счетов на {{v1}}? Клиенты получат уведомления{{v2}}.": "Issue {{v0}} invoices for {{v1}}? Clients will receive notifications{{v2}}.",
 "Выставить {{v0}} счетов на сумму {{v1}} за {{v2}}? Клиенты получат уведомления.": "Issue {{v0}} invoices for {{v1}} dated {{v2}}? Clients will receive notifications.",
 "Выставить счета": "Issue invoices",
 "Выставить счета ({{v0}})": "Issue invoices ({{v0}})",
 "Выставлено счетов: {{v0}} на {{v1}}{{v2}}": "Invoices issued: {{v0}} for {{v1}}{{v2}}",
 "Выставлено счетов: {{v0}} на {{v1}}{{v2}}.{{v3}}": "Invoices issued: {{v0}} for {{v1}}{{v2}}.{{v3}}",
 "Глобальный процент успешно обновлен": "Global percentage updated successfully",
 "Да, удалить": "Yes, delete",
 "Данные профиля отсутствуют или ещё загружаются.": "Profile data is missing or still loading.",
 "Данные успешно обновлены": "Data updated successfully",
 "Данные успешно сохранены": "Data saved successfully",
 "Данные успешно сохранены:": "Data saved successfully:",
 "Дата регистрации": "Registration date",
 "Дата создания": "Created on",
 "Дата статуса": "Status date",
 "Дата статуса:": "Status date:",
 "Действие": "Action",
 "Действия": "Actions",
 "Добавить": "Add",
 "Добавить в базу": "Add to database",
 "Добавить примечание": "Add a note",
 "Добавить счёт для": "Add an invoice for",
 "Добавить трек": "Add track",
 "Добавить трек клиента": "Add client's track",
 "Добавить трек номер": "Add tracking number",
 "Добавить утерянный товар": "Add a lost item",
 "Добавить филиал": "Add a branch",
 "Добавлен": "Added",
 "Добавлен вручную": "Added manually",
 "Добавлена:": "Added:",
 "Добавлено:": "Added:",
 "Добавлено: {{v0}} — {{v1}}": "Added: {{v0}} — {{v1}}",
 "Дополнительная информация": "Additional information",
 "Доступ запрещён": "Access denied",
 "Доступ к таблице: «Все, у кого есть ссылка — Читатель». Если в ссылке есть": "Table access: “Anyone with the link — Viewer”. If the link contains",
 "Загрузить": "Upload",
 "Загрузить баннер": "Upload banner",
 "Загрузить договор": "Upload contract",
 "Загрузить полную историю": "Load full history",
 "Закладка обновлена": "Bookmark updated",
 "Закладка удалена у пользователя": "Bookmark removed from the user",
 "Закрыть": "Close",
 "Записать всё равно": "Save anyway",
 "Записей": "Entries",
 "Заполните все поля": "Fill in all fields",
 "Из таблицы": "From the table",
 "Изменения успешно сохранены": "Changes saved successfully",
 "Изменить": "Edit",
 "Изменить вес": "Change weight",
 "Изменить статус": "Change status",
 "Изменить статус трека": "Change track status",
 "Или введите трек-номер": "Or enter the tracking number",
 "Имя": "First name",
 "Имя, телефон, username или код": "Name, phone, username or code",
 "Имя, телефон, личный код или username": "Name, phone, personal code or username",
 "Информация": "Information",
 "История": "History",
 "История (": "History (",
 "История бонусов для": "Bonus history for",
 "История обновлений:": "Update history:",
 "История приходов": "Arrivals history",
 "История счетов": "Invoice history",
 "Итого:": "Total:",
 "Ищу штрих-код… {{v0}}": "Looking for a barcode… {{v0}}",
 "К выставлению": "To invoice",
 "К выставлению:": "To invoice:",
 "Камера не найдена. Сфотографируйте штрих-код или введите номер вручную.": "Camera not found. Take a photo of the barcode or enter the number manually.",
 "Клиент найден: {{v0}}": "Client found: {{v0}}",
 "Клиент:": "Client:",
 "Клиента «": "Client “",
 "Клиентов": "Clients",
 "Клиенты увидят его в счёте": "Clients will see it in the invoice",
 "Кол-во товаров": "Number of items",
 "Кол-во:": "Qty:",
 "Количество (шт)": "Quantity (pcs)",
 "Копию в Google сохранить не удалось: повторите кнопкой ниже.": "Could not save the copy to Google: retry with the button below.",
 "Копия в Google не сохранена для записей:": "The Google copy was not saved for entries:",
 "Копия сохранена в Google": "Copy saved to Google",
 "Копия сохранена в Google.": "Copy saved to Google.",
 "Личный (VIP)": "Personal (VIP)",
 "Личный тариф пользователя (₸ за кг):": "User's personal rate (₸ per kg):",
 "Личный тариф сохранён": "Personal rate saved",
 "Личный тариф убран": "Personal rate removed",
 "Личный тариф, например 1400": "Personal rate, e.g. 1400",
 "Массовая загрузка": "Bulk upload",
 "Массовая загрузка утеренных товаров": "Bulk upload of lost items",
 "Массовое добавление": "Bulk add",
 "Массовое добавление треков": "Bulk add tracks",
 "Мой карго": "My cargo",
 "На фото штрих-код не прочитался. Нужна резкая картинка, где код занимает заметную часть кадра (не меньше трети ширины). Или введите номер вручную.": "The barcode could not be read from the photo. Use a sharp image where the code takes up a noticeable part of the frame (at least a third of the width), or enter the number manually.",
 "Нажмите на день в таблице, чтобы открыть его приходы.": "Click a day in the table to open its arrivals.",
 "Название филиала:": "Branch name:",
 "Найден пользователь: {{v0}} {{v1}}": "User found: {{v0}} {{v1}}",
 "Найти": "Find",
 "Например: заберите посылку до пятницы": "For example: pick up your parcel by Friday",
 "Например: оплатить до пятницы": "For example: pay by Friday",
 "Начислить": "Credit",
 "Не выбрано": "Not selected",
 "Не добавлен": "Not added",
 "Не оплачены": "Unpaid",
 "Не удалось выставить счета": "Could not issue invoices",
 "Не удалось загрузить историю приходов": "Could not load arrivals history",
 "Не удалось загрузить оферту": "Could not load the offer",
 "Не удалось загрузить приёмку": "Could not load the intake",
 "Не удалось загрузить профиль": "Could not load the profile",
 "Не удалось загрузить файл": "Could not upload the file",
 "Не удалось запустить камеру. Сфотографируйте штрих-код или введите номер вручную.": "Could not start the camera. Take a photo of the barcode or enter the number manually.",
 "Не удалось изменить": "Could not change",
 "Не удалось найти посылку": "Could not find the parcel",
 "Не удалось обновить закладку": "Could not update the bookmark",
 "Не удалось обновить профиль": "Could not update the profile",
 "Не удалось открыть фото.": "Could not open the photo.",
 "Не удалось отправить копию": "Could not send the copy",
 "Не удалось прочитать таблицу": "Could not read the table",
 "Не удалось разобрать фото. Введите номер вручную.": "Could not process the photo. Enter the number manually.",
 "Не удалось создать счёт": "Could not create the invoice",
 "Не удалось сохранить": "Could not save",
 "Не удалось сохранить копию в Google": "Could not save the copy to Google",
 "Не удалось удалить": "Could not delete",
 "Не удалось удалить файл": "Could not delete the file",
 "Не читается? Нажмите «Сфотографировать код»: снимок обычно читается лучше, чем живая картинка.": "Not reading? Press “Take a photo of the code”: a photo usually reads better than the live image.",
 "Неизвестен": "Unknown",
 "Неизвестно": "Unknown",
 "Необходимо заполнить все поля": "All fields must be filled in",
 "Нет выбранных закладок": "No bookmarks selected",
 "Нет данных пользователя для загрузки": "No user data to load",
 "Нет записей, по которым ещё не выставлен счёт.": "There are no entries without an invoice yet.",
 "Нет операций": "No transactions",
 "Нет рефералов": "No referrals",
 "Нет треков для добавления": "No tracks to add",
 "Ник из адреса доставки клиента. По нему распознаются этикетки посылок.": "The nickname from the client's delivery address. Parcel labels are recognised by it.",
 "Новые бонусы": "New bonuses",
 "Новый вес для {{v0}}, кг": "New weight for {{v0}}, kg",
 "Новый пароль (оставьте пустым, чтобы не менять):": "New password (leave empty to keep it):",
 "Новый процент": "New percentage",
 "Новый счёт": "New invoice",
 "Новый филиал успешно добавлен": "New branch added successfully",
 "Номер": "Number",
 "Номер для звонка": "Phone number for calls",
 "Номер счёта": "Invoice number",
 "Номер:": "Number:",
 "Обновить выбранные": "Update selected",
 "Обновить процент": "Update percentage",
 "Обновить филиал": "Update branch",
 "Общая сумма": "Total amount",
 "Общее кол-во": "Total quantity",
 "Общее примечание ко всем счетам (необязательно). Своё примечание клиенту можно написать в таблице выше": "A general note for all invoices (optional). An individual note for a client can be written in the table above",
 "Общий": "General",
 "Общий вес": "Total weight",
 "Общий тариф": "General rate",
 "Общий тариф нужно указать числом, например 1800": "The general rate must be a number, e.g. 1800",
 "Общий тариф сохранён": "General rate saved",
 "Он показывается на странице «Публичная оферта» (доступна без входа). Если оставить поле пустым, показывается встроенный текст.": "It is shown on the “Public offer” page (available without signing in). If the field is left empty, the built-in text is shown.",
 "Описание": "Description",
 "Оплата и склад по филиалам": "Payment and warehouse by branch",
 "Оплачено": "Paid",
 "Оплачены": "Paid",
 "Открываю карточку…": "Opening the card…",
 "Открыть карточку клиента": "Open client card",
 "Открыть страницу": "Open page",
 "Открыть треки": "Open tracks",
 "Отменены": "Cancelled",
 "Отменить": "Cancel",
 "Отменить счёт": "Cancel invoice",
 "Отменить счёт {{v0}}?": "Cancel invoice {{v0}}?",
 "Отмечен оплаченным": "Marked as paid",
 "Отправить в Google": "Send to Google",
 "Отправить счёт": "Send invoice",
 "Отправка...": "Sending...",
 "Оферта сохранена": "Offer saved",
 "Очерёдность: личный тариф клиента (VIP, в карточке клиента) → тариф филиала → общий.": "Order of priority: the client's personal rate (VIP, in the client card) → branch rate → general rate.",
 "Ошибка": "Error",
 "Ошибка при загрузке закладок": "Failed to load bookmarks",
 "Ошибка при загрузке полной истории": "Failed to load the full history",
 "Ошибка при загрузке пользователей": "Failed to load users",
 "Ошибка при загрузке рефералов": "Failed to load referrals",
 "Ошибка при массовом добавлении треков": "Failed to add tracks in bulk",
 "Ошибка при массовом обновлении": "Failed to update in bulk",
 "Ошибка при обновлении бонусов": "Failed to update bonuses",
 "Ошибка при обновлении данных": "Failed to update data",
 "Ошибка при обновлении процента пользователя": "Failed to update the user's percentage",
 "Ошибка при операции": "Operation failed",
 "Ошибка при оплате счёта": "Failed to pay the invoice",
 "Ошибка при применении трека": "Failed to apply the track",
 "Ошибка при редактировании счёта": "Failed to edit the invoice",
 "Ошибка при сканировании": "Scanning error",
 "Ошибка при создании счёта": "Failed to create the invoice",
 "Ошибка при сохранении глобального процента": "Failed to save the global percentage",
 "Ошибка при сохранении данных": "Failed to save data",
 "Ошибка при сохранении данных:": "Failed to save data:",
 "Ошибка при сохранении изменений": "Failed to save changes",
 "Ошибка при удалении пользователя": "Failed to delete the user",
 "Ошибка при удалении счёта": "Failed to delete the invoice",
 "Ошибка при удалении трека": "Failed to delete the track",
 "Ошибка: {{v0}}": "Error: {{v0}}",
 "Пароль должен содержать от 6 до 64 символов": "The password must be 6 to 64 characters long",
 "Партия (дата)": "Batch (date)",
 "По статусам": "By status",
 "По филиалам": "By branch",
 "Повторить загрузку": "Retry loading",
 "Подождите…": "Please wait…",
 "Подсветку включить не удалось.": "Could not turn on the light.",
 "Подтвердить": "Confirm",
 "Поиск": "Search",
 "Поиск по имени или телефону": "Search by name or phone",
 "Поиск по имени, фамилии или телефону": "Search by first name, last name or phone",
 "Поиск по клиенту, телефону, счёту...": "Search by client, phone, invoice...",
 "Пока пусто.": "Nothing here yet.",
 "Показать ещё": "Show more",
 "Поле процента пустое": "The percentage field is empty",
 "Поле трек не может быть пустым": "The track field cannot be empty",
 "Полная история загружена": "Full history loaded",
 "Пользователи (упрощённый список)": "Users (simplified list)",
 "Пользователь": "User",
 "Пользователь с номером {{v0}} не найден": "User with number {{v0}} not found",
 "Пользователь удалён": "User deleted",
 "Поместите штрих-код в зелёную рамку и держите ровно 1–3 секунды. Нажимать на экран не нужно — код читается сам.": "Place the barcode in the green frame and hold it steady for 1–3 seconds. No need to tap the screen — the code is read automatically.",
 "Последний отсканированный ID:": "Last scanned ID:",
 "Посмотреть рефералов": "View referrals",
 "Посылка {{v0}} → {{v1}} {{v2}}{{v3}}": "Parcel {{v0}} → {{v1}} {{v2}}{{v3}}",
 "Посылка {{v0}}: {{v1}}. Выберите клиента вручную.": "Parcel {{v0}}: {{v1}}. Choose the client manually.",
 "Потеряшки": "Lost items",
 "Предедущая страница": "Previous page",
 "Примечание для клиента (необязательно)": "Note for the client (optional)",
 "Примечание к счетам (необязательно)": "Note for invoices (optional)",
 "Примечание к счёту {{v0}} (клиент увидит его в счёте; пусто — убрать)": "Note for invoice {{v0}} (the client will see it in the invoice; empty — remove)",
 "Примечание сохранено": "Note saved",
 "Примечание только для этого клиента (например, ссылка на постамат)": "Note for this client only (e.g. a parcel locker link)",
 "Принял": "Accepted by",
 "Приходы за": "Arrivals for",
 "Приёмка": "Intake",
 "Пробить сканером...": "Scan with the scanner...",
 "Произошла ошибка при добавлении трека": "An error occurred while adding the track",
 "Произошла ошибка при добавлении/редактировании филиала": "An error occurred while adding/editing the branch",
 "Произошла ошибка при удалении филиала": "An error occurred while deleting the branch",
 "Пропущено строк таблицы:": "Table rows skipped:",
 "Профиль загружен": "Profile loaded",
 "Профиль:": "Profile:",
 "Процент": "Percentage",
 "Процент пользователя обновлен": "The user's percentage was updated",
 "Пусто — показывается встроенный текст. Нажмите «Взять текущий текст», чтобы начать с него.": "Empty — the built-in text is shown. Press “Use current text” to start from it.",
 "Разбираю фото… {{v0}}%": "Processing the photo… {{v0}}%",
 "Разметка:": "Markup:",
 "Разрешите доступ к камере в настройках браузера для этого сайта.": "Allow camera access for this site in your browser settings.",
 "Рассылка": "Mailing",
 "Расширить": "Expand",
 "Редактирование пользователя": "Edit user",
 "Редактировать": "Edit",
 "Редактировать закладку": "Edit bookmark",
 "Реквизиты сохранены": "Details saved",
 "Рефералы пользователя:": "User's referrals:",
 "Роль": "Role",
 "Роль:": "Role:",
 "Свежие по дате": "Newest first",
 "Свернуть": "Collapse",
 "Сейчас применяется:": "Currently applied:",
 "Сканер посылки": "Parcel scanner",
 "Сканер штрих-кода": "Barcode scanner",
 "Сканирование QR доступно только администраторам": "QR scanning is available to administrators only",
 "Сканирование QR-кода": "QR code scanning",
 "Сканирование посылок": "Parcel scanning",
 "Сканировать QR": "Scan QR",
 "Скачать файл": "Download file",
 "Сменить клиента": "Change client",
 "Сначала выберите дату и статус, потом сканируйте посылки": "First choose the date and status, then scan the parcels",
 "Снять выбор": "Clear selection",
 "Создать": "Create",
 "Создать счёт": "Create invoice",
 "Создать/обновить трек {{v0}} в общей базе?": "Create/update track {{v0}} in the shared database?",
 "Создаётся автоматически из личного кода клиента: XXX-0001, XXX-0002…": "Created automatically from the client's personal code: XXX-0001, XXX-0002…",
 "Сортировка по активности": "Sort by activity",
 "Состояние": "State",
 "Сохранение...": "Saving...",
 "Сохранить": "Save",
 "Сохранить изменения": "Save changes",
 "Списать": "Deduct",
 "Списать/начислить баллы": "Deduct/add points",
 "Списать/начислить баллы для": "Deduct/add points for",
 "Список посылок": "Parcel list",
 "Список треков": "Track list",
 "Список треков для массового добавления:": "List of tracks for bulk adding:",
 "Ссылка на Google-таблицу": "Google Sheets link",
 "Ссылка на ватсап": "WhatsApp link",
 "Ссылка на инструкцию (youtube, vimeo)": "Instruction link (YouTube, Vimeo)",
 "Ссылка на оплату (Kaspi и т.п.)": "Payment link (Kaspi etc.)",
 "Ссылка показывается клиенту кнопкой «Оплатить» в неоплаченном счёте. У каждого филиала своя.": "The link is shown to the client as a “Pay” button in an unpaid invoice. Each branch has its own.",
 "Старые по дате": "Oldest first",
 "Статистика": "Statistics",
 "Статус": "Status",
 "Статусы": "Statuses",
 "Сумма": "Amount",
 "Сумма (₸) *": "Amount (₸) *",
 "Сумма баллов": "Points amount",
 "Сумма появится после ввода веса": "The amount will appear after entering the weight",
 "Суммы расходятся со столбцом Payment в": "Amounts differ from the Payment column in",
 "Счета выставлены на": "Invoices issued for",
 "Счета из таблицы поступлений": "Invoices from the arrivals table",
 "Счета отсутствуют": "No invoices",
 "Счетов нет": "No invoices",
 "Счёт отменён": "Invoice cancelled",
 "Счёт отправлен клиенту": "Invoice sent to the client",
 "Счёт удалён": "Invoice deleted",
 "Счёт успешно создан": "Invoice created successfully",
 "Тариф": "Rate",
 "Тариф филиала сохранён": "Branch rate saved",
 "Тариф филиала убран — действует общий": "Branch rate removed — the general rate applies",
 "Тариф, ₸/кг": "Rate, ₸/kg",
 "Тарифы, ₸/кг": "Rates, ₸/kg",
 "Текст \"О нас\"": "“About us” text",
 "Текст \"Товары которые нельзя заказывать\"": "“Items you cannot order” text",
 "Текст оферты.": "Offer text.",
 "Текст очищен: будет показан встроенный вариант": "Text cleared: the built-in version will be shown",
 "Текущий договор:": "Current contract:",
 "Текущий статус:": "Current status:",
 "Текущий файл:": "Current file:",
 "Телефон:": "Phone:",
 "Тип:": "Type:",
 "Требуется авторизация администратора": "Administrator sign-in is required",
 "Трек": "Track",
 "Трек номер:": "Tracking number:",
 "Трек применён в базе": "Track applied in the database",
 "Трек удалён": "Track deleted",
 "Трека": "Track",
 "Треки": "Tracks",
 "Треки (по статусам)": "Tracks (by status)",
 "Треки клиента": "Client's tracks",
 "Треки отсутствуют": "No tracks",
 "Треки прикрепленные пользователями, но не найденные": "Tracks attached by users but not found",
 "Треки успешно обновлены или созданы": "Tracks updated or created successfully",
 "Убрать": "Remove",
 "Убрать у клиента": "Remove from client",
 "Удалить": "Delete",
 "Удалить {{v0}} закладок у пользователя и соответствующие треки из базы?": "Delete {{v0}} bookmarks from the user and the corresponding tracks from the database?",
 "Удалить {{v0}} закладок у пользователя?": "Delete {{v0}} bookmarks from the user?",
 "Удалить выбранные из базы": "Delete selected from the database",
 "Удалить закладку {{v0}} у пользователя?": "Delete bookmark {{v0}} from the user?",
 "Удалить запись {{v0}} — {{v1}}?": "Delete entry {{v0}} — {{v1}}?",
 "Удалить из базы": "Delete from the database",
 "Удалить профиль": "Delete profile",
 "Удалить счёт {{v0}} безвозвратно?": "Delete invoice {{v0}} permanently?",
 "Удалить трек {{v0}} из системы? Это действие повлияет на всех пользователей.": "Delete track {{v0}} from the system? This will affect all users.",
 "Укажите вес в кг, например 2.85": "Enter the weight in kg, e.g. 2.85",
 "Укажите клиента": "Specify the client",
 "Укажите сумму больше нуля": "Enter an amount greater than zero",
 "Уровень": "Level",
 "Успешно загружено!!": "Uploaded successfully!!",
 "Установить": "Set",
 "Установить статус выбранным закладкам ({{v0}})?": "Set the status for the selected bookmarks ({{v0}})?",
 "Файл загружен": "File uploaded",
 "Файл оферты (PDF, DOC, DOCX)": "Offer file (PDF, DOC, DOCX)",
 "Фамилия": "Last name",
 "Филиал": "Branch",
 "Филиал не указан": "Branch not specified",
 "Филиал успешно обновлен": "Branch updated successfully",
 "Филиал успешно удален": "Branch deleted successfully",
 "Филиала": "Branch",
 "Фильтр:": "Filter:",
 "Фильтры и массовые операции — ниже. Нажмите «Открыть треки», чтобы начать работу.": "Filters and bulk operations are below. Press “Open tracks” to get started.",
 "Функция еще в разработке...": "This feature is still under development...",
 "Хозяин посылки не найден, выберите клиента вручную": "The parcel owner was not found, choose the client manually",
 "Цена за кг": "Price per kg",
 "Читаю…": "Reading…",
 "баллов —": "points —",
 "без username": "no username",
 "все счета выставлены": "all invoices issued",
 "выставлен": "issued",
 "день": "day",
 "добавлен ({{v0}})": "added ({{v0}})",
 "ждут счёта:": "awaiting an invoice:",
 "запасной: для филиалов без своей цены": "fallback: for branches without their own price",
 "изменить": "edit",
 "изменить ▼": "edit ▼",
 "индивидуальных примечаний: {{v0}}": "individual notes: {{v0}}",
 "к выставлению": "to invoice",
 "как общий": "same as general",
 "кг •": "kg •",
 "кг,": "kg,",
 "личный": "personal",
 "меню": "menu",
 "не задан": "not set",
 "не задан — показывается общий адрес": "not set — the general address is shown",
 "не привязан": "not linked",
 "нет": "no",
 "нет в базе. Проверьте номер или добавьте посылку.": "not in the database. Check the number or add the parcel.",
 "нет приходов": "no arrivals",
 "нет ссылки": "no link",
 "общий": "general",
 "общий {{v0}}": "general {{v0}}",
 "общий не задан": "general not set",
 "ожидает": "waiting",
 "открыть": "open",
 "подробнее ▼": "details ▼",
 "с общим примечанием": "with a general note",
 "свернуть ▲": "collapse ▲",
 "своя цена не задана — действует общая": "own price not set — the general one applies",
 "сегодня": "today",
 "ссылка есть": "link set",
 "стр. {{v0}}: {{v1}}": "row {{v0}}: {{v1}}",
 "строках (отмечены ⚠). Обычно это клиенты со скидкой: задайте им личный тариф в «Все пользователи → Изменить».": "rows (marked ⚠). These are usually clients with a discount: set a personal rate for them in “All users → Edit”.",
 "счетов ·": "invoices ·",
 "тариф не задан": "rate not set",
 "тариф филиала": "branch rate",
 "удалить": "delete",
 "указать": "specify",
 "шт •": "pcs •",
 "шт,": "pcs,",
 "— клиентов:": "— clients:",
 "₸/кг": "₸/kg",
 "← Вернуться к информации": "← Back to information",
 "← На сайт": "← To the site",
 "← Назад": "← Back",
 "⏳ Ожидает": "⏳ Waiting",
 "⚖️ Приёмка": "⚖️ Intake",
 "✎ Примечание": "✎ Note",
 "✎ примечание": "✎ note",
 "✓ Выставить {{v0}} счетов": "✓ Issue {{v0}} invoices",
 "✓ Оплачено": "✓ Paid",
 "✓ Отправить счёт": "✓ Send invoice",
 "✕ Отмена": "✕ Cancel",
 "＋ Примечание": "＋ Note",
 "📋 Управление счетами": "📋 Invoice management",
 "📦 Треки (": "📦 Tracks (",
 "📷 Сканировать": "📷 Scan",
 "📷 Сканировать камерой телефона": "📷 Scan with the phone camera",
 "📷 Сканировать посылку": "📷 Scan a parcel",
 "📸 Сфотографировать код": "📸 Take a photo of the code",
 "🔦 Включить подсветку": "🔦 Turn on the light",
 "🔦 Выключить подсветку": "🔦 Turn off the light",
 "🖼 Фото из галереи": "🖼 Photo from gallery",
 "% Глобальный процент партнера": "% Global partner percentage",
 "— выделение; абзацы разделяйте пустой строкой.": "— emphasis; separate paragraphs with an empty line.",
 "— заголовок документа;": "— document title;",
 "— необязательно; ссылка на скачивание показывается на странице, если текст не задан.": "— optional; the download link is shown on the page if the text is not set.",
 "— подзаголовок;": "— subtitle;",
 "— раздел (сворачивается);": "— section (collapsible);",
 "— список;": "— list;",
 "В файле не найдено треков": "No tracks found in the file",
 "В файле больше 2000 треков — разбейте на части": "The file has more than 2000 tracks — split it into parts",
 "Файл {{v0}}: найдено треков {{v1}}{{v2}}{{v3}}. Проверьте дату и статус и нажмите «Загрузить».": "File {{v0}}: {{v1}} tracks found{{v2}}{{v3}}. Check the date and status and press “Upload”.",
 ", код филиала {{v0}}": ", branch code {{v0}}",
 ", дата {{v0}}": ", date {{v0}}",
 "Не удалось прочитать файл: {{v0}}": "Could not read the file: {{v0}}",
 "📎 Загрузить файл (xlsx, csv, txt)": "📎 Upload a file (xlsx, csv, txt)",
 "Вы уверены, что хотите удалить эту закладку?": "Are you sure you want to delete this bookmark?",
 "Закладка удалена": "Bookmark deleted",
 "Ошибка при удалении закладки": "Failed to delete the bookmark",
 "Описание:": "Description:",
 "Загрузка...": "Loading...",
 "Подтвердить получение": "Confirm receipt",
 "Токен отсутствует. Пожалуйста, войдите в систему снова.": "Session token is missing. Please sign in again.",
 "Username сохранён.": "Username saved.",
 "Не удалось сохранить username.": "Could not save the username.",
 "Ошибка при отправке запроса.": "Failed to send the request.",
 "Пароль успешно обновлен.": "Password updated successfully.",
 "Ошибка при смене пароля.": "Failed to change the password.",
 "Заполните обязательные поля": "Fill in the required fields",
 "Объявление обновлено": "Announcement updated",
 "Объявление создано и отправлено всем пользователям": "Announcement created and sent to all users",
 "Ошибка при сохранении объявления": "Failed to save the announcement",
 "Вы уверены?": "Are you sure?",
 "Объявление удалено": "Announcement deleted",
 "Ошибка при удалении объявления": "Failed to delete the announcement",
 "Доступ запрещен": "Access denied",
 "Управление объявлениями": "Manage announcements",
 "✕ Закрыть форму": "✕ Close form",
 "+ Новое объявление": "+ New announcement",
 "Заголовок *": "Title *",
 "Введите заголовок": "Enter a title",
 "Сообщение *": "Message *",
 "Введите сообщение": "Enter a message",
 "URL изображения": "Image URL",
 "💾 Обновить": "💾 Update",
 "💾 Создать": "💾 Create",
 "Отмена": "Cancel",
 "Объявления (": "Announcements (",
 "Объявлений нет": "No announcements",
 "Ошибка при загрузке архива": "Failed to load the archive",
 "Запись удалена из архива": "Entry removed from the archive",
 "Ошибка при удалении": "Failed to delete",
 "Загрузка архива...": "Loading archive...",
 "Архив пуст": "The archive is empty",
 "В архиве": "In archive",
 "УДАЛИТЬ": "DELETE",
 "История статусов": "Status history",
 "Добавлен в базу": "Added to database",
 "Загрузка…": "Loading…",
 "Показать ещё ({{v0}})": "Show more ({{v0}})",
 "Архив": "Archive",
 "Загрузка ...": "Loading ...",
 "Показано": "Shown",
 "из": "of",
 "архивированных посылок": "archived parcels",
 "Дата регистрации клиентом:": "Registered by client on:",
 "нет данных": "no data",
 "Дата получения:": "Received on:",
 "Страница": "Page",
 "Баннер": "Banner",
 "Логотип": "Logo",
 "Надёжный карго-сервис с отслеживанием и прозрачной логистикой": "Reliable cargo service with tracking and transparent logistics",
 "Войти": "Sign in",
 "Регистрация": "Registration",
 "Перейти в систему": "Go to the system",
 "Публичная оферта": "Public offer",
 "Ошибка при обновлении и получении счета: {{v0}}": "Error while updating and loading the invoice: {{v0}}",
 "Загрузка счета...": "Loading invoice...",
 "Нет неоплаченных счетов": "No unpaid invoices",
 "Счёт за доставку от": "Delivery invoice dated",
 "Поступило заказов -": "Orders received -",
 "шт": "pcs",
 "Вес": "Weight",
 "кг, сумма к оплате": "kg, amount due",
 "Главная": "Home",
 "Посылки": "Parcels",
 "Профиль": "Profile",
 "Панель управления": "Control panel",
 "Поиск...": "Search...",
 "Найдено:": "Found:",
 "Трек-код": "Tracking code",
 "Дата": "Date",
 "Предыдущая страница": "Previous page",
 "Следующая страница": "Next page",
 "Номер страницы:": "Page number:",
 "Кол-во страниц:": "Pages:",
 "Доступен 09:00 - 18:00 (МСК)": "Available 09:00 - 18:00 (MSK)",
 "Статус клиента": "Client status",
 "Бонусные баллы": "Bonus points",
 "Общие затраты": "Total spent",
 "Рефералы": "Referrals",
 "Информация аккаунта": "Account information",
 "Успешно добавлен": "Added successfully",
 "404 - Страница не найдена": "404 - Page not found",
 "К сожалению, запрашиваемая страница не существует.": "Sorry, the requested page does not exist.",
 "Вернуться на главную": "Back to home",
 "Ошибка при получении уведомлений": "Failed to load notifications",
 "Уведомление удалено": "Notification deleted",
 "Счета": "Invoices",
 "Объявления": "Announcements",
 "Уведомления": "Notifications",
 "Загрузка уведомлений...": "Loading notifications...",
 "Нет уведомлений": "No notifications",
 "Трек:": "Track:",
 "Сумма:": "Amount:",
 "Вес:": "Weight:",
 "кг": "kg",
 "Объявление": "Announcement",
 "✓ Прочитано": "✓ Read",
 "● Новое": "● New",
 "Получение подтверждено!": "Receipt confirmed!",
 "Произошла ошибка при подтверждении получения.": "An error occurred while confirming receipt.",
 "посылок": "parcels",
 "неизвестно": "unknown",
 "Данные скопированы в буфер обмена": "Copied to clipboard",
 "Не удалось скопировать — попробуйте вручную": "Could not copy — try manually",
 "Не удалось получить доступ к камере": "Could not access the camera",
 "Клиент найден!": "Client found!",
 "Клиент не найден": "Client not found",
 "Ошибка при поиске клиента": "Failed to search for the client",
 "Сканирование клиентов через QR": "Scan clients via QR",
 "Отсканируйте QR код клиента или введите номер телефона": "Scan the client's QR code or enter a phone number",
 "⚠️ Доступ к камере запрещен": "⚠️ Camera access denied",
 "Пожалуйста, разрешите доступ к камере в настройках браузера": "Please allow camera access in your browser settings",
 "🛑 Остановить сканирование": "🛑 Stop scanning",
 "📷 Начать сканирование": "📷 Start scanning",
 "Введите номер телефона клиента": "Enter the client's phone number",
 "🔍 Поиск": "🔍 Search",
 "Загрузка данных клиента...": "Loading client data...",
 "Данные клиента": "Client details",
 "Имя:": "Name:",
 "Номер телефона:": "Phone number:",
 "Не указан": "Not specified",
 "Статус:": "Status:",
 "Администратор": "Administrator",
 "Клиент": "Client",
 "Уровень:": "Level:",
 "Стандартный": "Standard",
 "Филиал:": "Branch:",
 "Бонусы:": "Bonuses:",
 "Дата регистрации:": "Registration date:",
 "Реферальный код:": "Referral code:",
 "📷 Отсканировать другого": "📷 Scan another",
 "Клиент с номером": "Client with number",
 "не найден": "not found",
 "Попробовать снова": "Try again",
 "Реферальная ссылка скопирована!": "Referral link copied!",
 "Пользователи, зарегистрированные по вашей реферальной ссылке": "Users registered via your referral link",
 "Фамилия:": "Last name:",
 "Партнерская программа": "Partner program",
 "Ваша реферальная ссылка:": "Your referral link:",
 "Пожалуйста, авторизуйтесь": "Please sign in",
 "Мой QR код": "My QR code",
 "Покажите этот QR код администратору для быстрого поиска вашей информации": "Show this QR code to the administrator to quickly find your information",
 "📥 Скачать QR код": "📥 Download QR code",
 "✅ Скопировано": "✅ Copied",
 "📋 Копировать номер": "📋 Copy number",
 "Ошибка при загрузке счетов": "Failed to load invoices",
 "Неоплаченные счета": "Unpaid invoices",
 "Дата:": "Date:",
 "Товаров:": "Items:",
 "тг": "KZT",
 "Не оплачено": "Not paid",
 "Не оплачен": "Not paid",
 "Оплачен": "Paid",
 "Отменён": "Cancelled",
 "Бонусы": "Bonuses",
 "Баланс бонусов": "Bonus balance",
 "У вас 1200 бонусов. Используйте их при оформлении заказа.": "You have 1200 bonuses. Use them when placing an order.",
 "Контакты": "Contacts",
 "Загрузка контактов...": "Loading contacts...",
 "Свяжитесь с нами": "Contact us",
 "Ваш филиал: {{v0}}. ": "Your branch: {{v0}}. ",
 "Выберите удобный для вас способ связи": "Choose the way to contact us that suits you",
 "Телефон": "Phone",
 "Позвонить": "Call",
 "Напишите нам": "Write to us",
 "Написать": "Write",
 "Наш канал": "Our channel",
 "Перейти": "Open",
 "Следить": "Follow",
 "Контакты не доступны в данный момент": "Contacts are not available at the moment",
 "Филиалы": "Branches",
 "Наши филиалы": "Our branches",
 "Владелец:": "Owner:",
 "Филиалы не найдены": "No branches found",
 "Мои счета": "My invoices",
 "Не удалось загрузить счета": "Could not load invoices",
 "Счетов пока нет": "No invoices yet",
 "Счёт": "Invoice",
 "Количество:": "Quantity:",
 "Оплатить": "Pay",
 "Отслеживание груза": "Cargo tracking",
 "Реал-тайм информация о статусе посылки": "Real-time information on the parcel status",
 "Консультация по расчету": "Cost calculation advice",
 "Помощь с расчетом стоимости доставки": "Help calculating the delivery cost",
 "Оформление документов": "Document processing",
 "Помощь в оформлении таможенных документов": "Help with customs documents",
 "Логистические решения": "Logistics solutions",
 "Индивидуальные предложения для крупных грузов": "Individual offers for large shipments",
 "Сколько времени занимает доставка?": "How long does delivery take?",
 "Срок доставки товаров из Китая в Казахстан составляет 8–15 дней. Счёт дней начинается с момента отправки товара со склада в Китае. В случае форс-мажора, праздников или работы таможни, сроки доставки могут измениться. Карго не несёт ответственность за задержки, вызванные указанными обстоятельствами.": "Delivery from China to Kazakhstan takes 8–15 days. The count starts from the moment the goods leave the warehouse in China. In case of force majeure, holidays or customs delays, delivery times may change. The cargo company is not responsible for delays caused by these circumstances.",
 "Как работает страхование груза?": "How does cargo insurance work?",
 "Клиент может оформить страховку при отправке через Карго. Стоимость страховки: 1% от стоимости груза (минимум 2 500 ₸). Страховка покрывает только заявленную стоимость товара по скриншоту. Если груз не застрахован, Карго не несёт ответственности за повреждение, потерю или недостачу. Отказаться от страховки можно только до отправки груза со склада.": "The client can purchase insurance when shipping via the cargo company. Insurance costs 1% of the cargo value (minimum 2,500 ₸). It covers only the declared value of the goods shown in the screenshot. If the cargo is not insured, the cargo company is not liable for damage, loss or shortage. Insurance can be declined only before the cargo leaves the warehouse.",
 "Какие документы требуются?": "What documents are required?",
 "Требуется паспорт и таможенный декларат. Наш менеджер поможет вам с оформлением всех необходимых документов. Для хрупких товаров требуется деревянная обрешётка (стоимость 10 USD). Клиент обязан заранее уведомить карго о хрупком товаре.": "A passport and a customs declaration are required. Our manager will help you prepare all necessary documents. Fragile goods require wooden crating (10 USD). The client must notify the cargo company about fragile goods in advance.",
 "Какова ответственность компании?": "What is the company's liability?",
 "Компания отвечает только за товары, которые поступили на склад и отображены на сайте. Ответственность за сохранность груза несёт только филиал Карго, который принял товар. Если товар забирает третье лицо по доверенности, все риски переходят на клиента. Компания не несёт ответственность за содержимое посылок и претензии к интернет-магазинам.": "The company is responsible only for goods that have arrived at the warehouse and are shown on the website. Responsibility for the safety of the cargo lies only with the cargo branch that accepted the goods. If a third party collects the goods by proxy, all risks pass to the client. The company is not responsible for the contents of parcels or for claims against online stores.",
 "Можно ли отменить или вернуть заказ?": "Can an order be cancelled or returned?",
 "Отмена возможна только до выкупа товара у продавца. После выкупа, поступления на склад или отправки в Казахстан отмена и возврат денежных средств категорически невозможны. По прибытию товара в Казахстан отказ от товара не допускается ни при каких обстоятельствах.": "Cancellation is possible only before the goods are bought from the seller. After purchase, arrival at the warehouse or dispatch to Kazakhstan, cancellation and refunds are strictly not possible. Once the goods arrive in Kazakhstan, refusing them is not allowed under any circumstances.",
 "Как защищена моя личная информация?": "How is my personal information protected?",
 "Карго обеспечивает сохранность всей личной информации клиента. Карго не раскрывает личные данные третьим лицам, за исключением случаев, необходимых для исполнения обязательств по доставке товара. Карго не раскрывает содержимое заказов и не ведёт учёт количества товаров.": "The cargo company keeps all of the client's personal information safe. It does not disclose personal data to third parties, except where necessary to fulfil delivery obligations. It does not disclose the contents of orders and does not keep records of the quantity of goods.",
 "Менеджер": "Manager",
 "Услуги менеджера": "Manager services",
 "❓ Часто задаваемые вопросы": "❓ Frequently asked questions",
 "⏰ График работы менеджера": "⏰ Manager working hours",
 "📞 Телефон / WhatsApp:": "📞 Phone / WhatsApp:",
 "Понедельник": "Monday",
 "Выходной": "Day off",
 "Вторник–Пятница": "Tuesday–Friday",
 "Суббота–Воскресенье": "Saturday–Sunday",
 "Скачать оферту (файл)": "Download the offer (file)",
 "← Вернуться на главную": "← Back to home",
 "Требуется авторизация для доступа к QR функциям": "Sign-in is required to use QR features",
 "Настройки": "Settings",
 "Условия (файл):": "Terms (file):",
 "Открыть": "Open",
 "не загружен": "not uploaded",
 "Адрес склада (chinaAddress):": "Warehouse address (chinaAddress):",
 "не указан": "not specified",
 "Номер WhatsApp менеджера:": "Manager's WhatsApp number:",
 "Настройки не заданы": "Settings are not set",
 "Условия": "Terms",
 "Условия использования": "Terms of use",
 "Ознакомьтесь с информацией о нашем сервисе": "Read about our service",
 "📺 Инструкция": "📺 Instructions",
 "Посмотреть видеоинструкцию →": "Watch the video guide →",
 "💬 Связь с нами": "💬 Contact us",
 "Написать в WhatsApp →": "Write on WhatsApp →",
 "ℹ️ О нас": "ℹ️ About us",
 "⛔ Товары которые нельзя заказывать": "⛔ Items you cannot order",
 "📍 Адрес китайского склада": "📍 Chinese warehouse address",
 "📄 Документы": "📄 Documents",
 "Скачать договор и условия": "Download the contract and terms",
 "❓ Остались вопросы? Свяжитесь с нашей поддержкой": "❓ Still have questions? Contact our support",
 "Адрес склада 291cargo": "291cargo warehouse address",
 "Склад": "Warehouse",
 "Загрузка информации о складе...": "Loading warehouse information...",
 "Наш склад в Китае": "Our warehouse in China",
 "Отправьте посылку на этот адрес для дальнейшей доставки в Казахстан": "Send your parcel to this address for further delivery to Kazakhstan",
 "Адрес склада": "Warehouse address",
 "Адрес не задан": "Address is not set",
 "✓ Скопировано": "✓ Copied",
 "📋 Скопировать": "📋 Copy",
 "🔗 Поделиться": "🔗 Share",
 "Как отправить посылку?": "How to send a parcel?",
 "Скопируйте адрес": "Copy the address",
 "Нажмите кнопку \"Скопировать\" и скопируйте полный адрес нашего склада": "Press the \"Copy\" button to copy the full address of our warehouse",
 "Оформите доставку": "Arrange delivery",
 "Оформите доставку через местную логистическую компанию или доставку лично": "Arrange delivery through a local logistics company or deliver in person",
 "Получите трек-номер": "Get the tracking number",
 "Отправьте нам номер отслеживания через чат с менеджером": "Send us the tracking number via the manager chat",
 "Отслеживайте груз": "Track your cargo",
 "Смотрите статус доставки в своем личном кабинете в разделе \"Посылки\"": "Check the delivery status in your account, in the \"Parcels\" section",
 "💡 Полезные советы": "💡 Useful tips",
 "✓ Убедитесь, что посылка хорошо упакована": "✓ Make sure the parcel is well packed",
 "✓ Указывайте правильные размеры и вес": "✓ Provide correct dimensions and weight",
 "✓ Проверьте список запрещенного содержимого": "✓ Check the list of prohibited contents",
 "✓ Сохраняйте чеки и документы доставки": "✓ Keep receipts and delivery documents",
 "✓ Уведомляйте нас как можно раньше о отправке": "✓ Notify us about the shipment as early as possible",
 "Вопросы по адресу складу? Свяжитесь с нашей поддержкой через менеджера": "Questions about the warehouse address? Contact our support through the manager",
 "💬 Написать менеджеру": "💬 Message the manager",
 "Сообщения клиентам": "Messages to clients",
 "Все клиенты": "All clients",
 "Филиал: {{v0}}": "Branch: {{v0}}",
 "Выбранные клиенты ({{v0}})": "Selected clients ({{v0}})",
 "Выбранные клиенты": "Selected clients",
 "Не удалось загрузить данные": "Failed to load data",
 "выбранным клиентам: {{v0}}": "to selected clients: {{v0}}",
 "всем клиентам филиала «{{v0}}»: {{v1}}": "to all clients of the “{{v0}}” branch: {{v1}}",
 "всем клиентам: {{v0}}": "to all clients: {{v0}}",
 "Отправить сообщение {{v0}}? Оно придёт на сайт, в push и в Telegram. Отменить отправку нельзя.": "Send the message {{v0}}? It will arrive on the site, as a push and in Telegram. Sending cannot be undone.",
 "Отправить": "Send",
 "Отправлено клиентам: {{v0}} (push: {{v1}}, Telegram: {{v2}})": "Sent to clients: {{v0}} (push: {{v1}}, Telegram: {{v2}})",
 "пропущено: {{v0}}": "skipped: {{v0}}",
 "Не удалось отправить сообщение": "Failed to send the message",
 "Сообщение появится в уведомлениях на сайте, придёт push и в Telegram (если клиент привязал бота).": "The message will appear in the site notifications and arrive as a push and in Telegram (if the client has linked the bot).",
 "Кому": "To",
 "Всем клиентам филиала": "All clients of the branch",
 "Всем клиентам": "All clients",
 "Выберите филиал": "Select a branch",
 "Ваш филиал: {{v0}}. Писать можно только клиентам своего филиала.": "Your branch: {{v0}}. You can only write to clients of your branch.",
 "Поиск клиента: имя, телефон, ID...": "Find a client: name, phone, ID...",
 "Клиенты не найдены": "No clients found",
 "Выбрать всех найденных": "Select all found",
 "Очистить": "Clear",
 "Клиентов: {{v0}} · push-подписок у клиентов: {{v1}} · в Telegram: {{v2}}": "Clients: {{v0}} · clients with push: {{v1}} · in Telegram: {{v2}}",
 "Сообщение": "Message",
 "Заголовок": "Title",
 "Например: Ваша посылка прибыла": "For example: Your parcel has arrived",
 "Текст": "Text",
 "Выберите хотя бы одного клиента": "Select at least one client",
 "Последние рассылки": "Recent mailings",
 "Пока ничего не отправлялось": "Nothing has been sent yet",
 "Отправитель": "Sender",
 "Получили": "Received",
 "Вес посылки, г": "Parcel weight, g",
 "Изменить трек": "Edit track number",
 "Итого за день": "Total for the day",
 "Ищу посылку…": "Looking up the parcel…",
 "Некорректный трек-номер": "Invalid track number",
 "Новый вес для {{v0}}, г": "New weight for {{v0}}, g",
 "Общий вес, г": "Total weight, g",
 "Оставить": "Keep",
 "Открывать камеру после каждой записи": "Open the camera after each entry",
 "Отсканируйте или введите трек": "Scan or type the track number",
 "Посылка {{v0}} уже принималась {{v1}} ({{v2}}, {{v3}}). Принять ещё раз?": "Parcel {{v0}} was already received on {{v1}} ({{v2}}, {{v3}}). Receive it again?",
 "Принять ещё раз": "Receive again",
 "Приход за": "Arrivals for",
 "Сканировать камерой": "Scan with the camera",
 "Сумма к оплате": "Amount due",
 "Трек-номер": "Track number",
 "Трек-номер посылки ({{v0}}, {{v1}})": "Parcel track number ({{v0}}, {{v1}})",
 "Укажите вес в граммах целым числом, например 268": "Enter the weight in grams as a whole number, e.g. 268",
 "Эта посылка уже принималась {{v0}} ({{v1}}, {{v2}})": "This parcel was already received on {{v0}} ({{v1}}, {{v2}})",
 "Эта посылка уже принималась {{v0}} ({{v1}}, {{v2}}). Проверьте, не дубль ли это.": "This parcel was already received on {{v0}} ({{v1}}, {{v2}}). Check whether this is a duplicate.",
 "Этот трек уже принимался. Оставить всё равно?": "This track number was already received. Keep it anyway?",
 "без трека": "no track",
 "клиентов": "clients",
 "общий вес, г": "total weight, g",
 "посылок: {{v0}}": "parcels: {{v0}}",
 "сумма к оплате": "amount due",
 "Весь город": "Whole city",
 "всем клиентам города: {{v0}}": "to all clients of the city: {{v0}}",
 "Всем клиентам города": "All clients of the city",
 "Все филиалы города": "All branches of the city",
 "Ваш город: филиалы {{v0}}. Писать можно клиентам этих филиалов.": "Your city: branches {{v0}}. You can write to clients of these branches.",
 "Город (необязательно): филиалы одного города работают с клиентами друг друга": "City (optional): branches of the same city work with each other's clients",
 "Город:": "City:",
 "Выбранным клиентам": "To selected clients",
 "Калькулятор": "Calculator",
 "Сколько стоит доставка": "How much does delivery cost",
 "Не удалось загрузить тариф. Попробуйте позже.": "Could not load the rate. Please try again later.",
 "Тариф пока не задан. Уточните стоимость у менеджера филиала.": "The rate is not set yet. Ask the branch manager for the price.",
 "Ваш тариф: {{v0}} за кг": "Your rate: {{v0}} per kg",
 "ваш личный тариф": "your personal rate",
 "тариф вашего филиала": "your branch rate",
 "общий тариф": "standard rate",
 "Вес посылки": "Parcel weight",
 "Единицы веса": "Weight units",
 "г": "g",
 "Количество одинаковых посылок": "Number of identical parcels",
 "Общий вес: {{v0}} г": "Total weight: {{v0}} g",
 "Введите вес, чтобы увидеть стоимость": "Enter the weight to see the price",
 "Расчёт примерный: итог определяется по весу посылки на складе.": "The estimate is approximate: the final price is set by the parcel weight at the warehouse.",
 "Размеры посылки, см (необязательно)": "Parcel dimensions, cm (optional)",
 "Длина, см": "Length, cm",
 "Ширина, см": "Width, cm",
 "Высота, см": "Height, cm",
 "Д": "L",
 "Ш": "W",
 "В": "H",
 "Объёмный вес = Д × Ш × В / {{v0}}. Оплачивается большее из фактического и объёмного веса.": "Volumetric weight = L × W × H / {{v0}}. The greater of the actual and volumetric weight is charged.",
 "Расчётный вес: {{v0}} г": "Chargeable weight: {{v0}} g",
 "фактический: {{v0}} г": "actual: {{v0}} g",
 "объёмный: {{v0}} г": "volumetric: {{v0}} g",
 "Объёмный вес больше фактического — стоимость считается по нему.": "The volumetric weight is greater than the actual one, so the price is based on it.",
 "Введите вес или размеры, чтобы увидеть стоимость": "Enter the weight or dimensions to see the price",
 "Коэффициент должен быть целым числом от 1000 до 20000, например 5000": "The coefficient must be a whole number from 1000 to 20000, e.g. 5000",
 "Коэффициент объёмного веса сохранён": "Volumetric weight coefficient saved",
 "Коэффициент объёмного веса": "Volumetric weight coefficient",
 "Д×Ш×В (см) / коэффициент = объёмный вес, кг. Показывается в калькуляторе клиентов": "L×W×H (cm) / coefficient = volumetric weight, kg. Used in the clients' calculator",
 "Отчёты": "Reports",
 "Должники": "Debtors",
 "Не удалось загрузить должников": "Failed to load debtors",
 "Не удалось загрузить сводку": "Failed to load the summary",
 "Не удалось выгрузить файл": "Failed to export the file",
 "Отправить {{v0}} напоминание об оплате ({{v1}})? Придёт на сайт, в push и в Telegram.": "Send a payment reminder to {{v0}} ({{v1}})? It will arrive on the site, as a push and in Telegram.",
 "Напомнить": "Remind",
 "Напоминание отправлено": "Reminder sent",
 "Не удалось отправить напоминание": "Failed to send the reminder",
 "Давность долга": "Debt age",
 "Любая давность": "Any age",
 "Старше 7 дней": "Older than 7 days",
 "Старше 14 дней": "Older than 14 days",
 "Старше 30 дней": "Older than 30 days",
 "Скачать CSV": "Download CSV",
 "Должников нет": "No debtors",
 "Счетов": "Invoices",
 "Дней": "Days",
 "Итого: должников {{v0}}": "Total debtors: {{v0}}",
 "Показаны первые 1000 должников.": "The first 1000 debtors are shown.",
 "Приход и оплаты по дням": "Arrivals and payments by day",
 "С даты": "From",
 "По дату": "To",
 "За этот период ничего не было": "Nothing in this period",
 "Посылок": "Parcels",
 "Вес, г": "Weight, g",
 "Выставлено": "Invoiced",
 "Итого": "Total",
 "Журнал действий": "Activity log",
 "Журнал": "Log",
 "Тип действий": "Action type",
 "Все действия": "All actions",
 "Клиенты": "Clients",
 "Тарифы": "Rates",
 "Рассылки": "Mailings",
 "Входы": "Logins",
 "админ": "admin",
 "филиал": "branch",
 "клиент": "client",
 "Поиск: сотрудник или клиент": "Search: employee or client",
 "Записей нет": "No entries",
 "Кто": "Who",
 "Что сделал": "Action",
 "Над чем": "Subject",
 "Подробности": "Details",
 "Страница {{v0}} из {{v1}}": "Page {{v0}} of {{v1}}",
 "записей: {{v0}}": "entries: {{v0}}",
 "Не удалось загрузить журнал": "Failed to load the log",
 "Вход в систему": "Login",
 "Приёмка: добавлена посылка": "Intake: parcel added",
 "Приёмка: изменена запись": "Intake: entry changed",
 "Приёмка: удалена запись": "Intake: entry deleted",
 "Приёмка: выставлены счета": "Intake: invoices issued",
 "Счёт выставлен": "Invoice issued",
 "Счёт изменён": "Invoice changed",
 "Счёт отмечен оплаченным": "Invoice marked as paid",
 "Клиент: данные изменены": "Client: data changed",
 "Клиент удалён": "Client deleted",
 "Личный тариф клиента": "Client's personal rate",
 "Процент бонуса клиента": "Client bonus percentage",
 "Бонусы начислены": "Bonuses added",
 "Бонусы списаны": "Bonuses spent",
 "Филиал добавлен": "Branch added",
 "Филиал изменён": "Branch changed",
 "Филиал удалён": "Branch deleted",
 "Реквизиты филиала": "Branch payment details",
 "Тариф филиала": "Branch rate",
 "Настройки изменены": "Settings changed",
 "Общий процент бонуса": "Global bonus percentage",
 "Рассылка клиентам": "Mailing to clients",
 "Сверка оплат с отчётом Kaspi": "Reconciliation with the Kaspi report",
 "Загрузить PDF-отчёт": "Upload PDF report",
 "PDF-отчёт Kaspi": "Kaspi PDF report",
 "Загрузите ежедневный «Отчёт по продажам» из Kaspi Pay. В нём есть время и сумма, но нет имён, поэтому счета ищутся по сумме. Файл читается в вашем браузере.": "Upload the daily “Sales report” from Kaspi Pay. It has the time and amount but no names, so invoices are matched by amount. The file is read in your browser.",
 "Или вставьте текст отчёта": "Or paste the report text",
 "Текст отчёта": "Report text",
 "Разобрать текст": "Parse the text",
 "Не удалось разобрать отчёт": "Failed to parse the report",
 "Не удалось прочитать PDF": "Failed to read the PDF",
 "продаж: {{v0}} на {{v1}}": "sales: {{v0}} for {{v1}}",
 "однозначных: {{v0}}": "clear matches: {{v0}}",
 "спорных: {{v0}}": "ambiguous: {{v0}}",
 "без счёта: {{v0}}": "no invoice: {{v0}}",
 "уже обработано: {{v0}}": "already processed: {{v0}}",
 "Отметить оплату {{v0}}": "Mark payment {{v0}}",
 "Выбор счёта {{v0}}": "Choose the invoice for {{v0}}",
 "— выберите счёт —": "— choose an invoice —",
 "нет неоплаченного счёта на эту сумму": "no unpaid invoice for this amount",
 "пропущена": "skipped",
 "обработана: {{v0}}": "processed: {{v0}}",
 "Пропустить": "Skip",
 "Отметить оплаченными счета: {{v0}} на сумму {{v1}}? Клиенты получат уведомление.": "Mark {{v0}} invoices as paid for {{v1}}? Clients will be notified.",
 "Отметить": "Mark",
 "Отмечено оплаченными: {{v0}}": "Marked as paid: {{v0}}",
 "не отмечено: {{v0}} ({{v1}})": "not marked: {{v0}} ({{v1}})",
 "Не удалось отметить оплаты": "Failed to mark the payments",
 "Пропустить продажу {{v0}} на {{v1}}? Она больше не будет предлагаться.": "Skip the sale {{v0}} for {{v1}}? It will no longer be suggested.",
 "Не удалось пропустить": "Failed to skip",
 "Отметить выбранные оплаченными ({{v0}})": "Mark selected as paid ({{v0}})",
 "уже обработана": "already processed",
 "счёт уже не ожидает оплаты": "the invoice is no longer awaiting payment",
 "сумма не совпала": "the amount did not match",
 "нет доступа к клиенту": "no access to the client",
 "счёт не найден": "invoice not found",
 "некорректные данные": "invalid data",
 "ошибка": "error",
 "Загрузка отправок из файла": "Shipment file import",
 "Оплата Kaspi пропущена": "Kaspi payment skipped",
 "Отправки": "Shipments",
 "Оплаты Kaspi": "Kaspi payments",
 "Режим": "Mode",
 "Отправлен": "Sent",
 "Прибыл": "Arrived",
 "Код": "Code",
 "Всего": "Total",
 "Создано": "Created",
 "Обновлено": "Updated",
 "Уже было": "Already set",
 "Дальше по статусу": "Further along",
 "Другая дата": "Other date",
 "Оплатить онлайн": "Pay online",
 "Карта, Apple Pay, Google Pay": "Card, Apple Pay, Google Pay",
 "Не удалось создать платёж. Попробуйте позже.": "Could not create the payment. Please try again later.",
 "Спасибо! Оплата принята, статус счёта обновится в течение минуты.": "Thank you! Payment received; the invoice status will update within a minute.",
 "Оплата не прошла. Попробуйте ещё раз.": "Payment failed. Please try again.",
 "Тестовая оплата получена (счёт в тестовом режиме не закрывается).": "Test payment received (invoices are not closed in test mode).",
 "Оплата получена, но счёт закрыть не удалось. Свяжитесь с филиалом, мы всё проверим.": "Payment received, but the invoice could not be closed. Please contact your branch and we will check.",
 "Активность клиентов": "Client activity",
 "Заходили сегодня": "Visited today",
 "за 7 дней": "last 7 days",
 "за 30 дней": "last 30 days",
 "всего клиентов": "total clients",
 "Отметки о заходах копятся с момента включения функции.": "Visit marks accumulate from the moment the feature was enabled.",
 "Кто заходил сегодня": "Who visited today",
 "Скрыть список": "Hide list",
 "Последний визит": "Last visit",
 "вчера": "yesterday",
 "Счёт (ID)": "Invoice (ID)",
 "Источник": "Source",
 "Заказ": "Order",
 "Пропущено": "Skipped",
 "Поля": "Fields",
 "Получателей": "Recipients",
 "Город": "City",
 "Телефон владельца": "Owner phone",
 "Владелец (ID)": "Owner (ID)",
 "Цена": "Price",
 "Валюта": "Currency",
 "Личный тариф": "Personal tariff",
 "Процент бонуса": "Bonus percent",
 "Коэффициент": "Coefficient",
 "Код клиента": "Client code",
 "Пароль изменён": "Password changed",
 "Ссылка оплаты изменена": "Payment link changed",
 "да": "yes",
 "онлайн-оплата Freedom Pay": "Freedom Pay online payment",
 "онлайн-оплата Freedom Pay (тест)": "Freedom Pay online payment (test)",
 "онлайн-оплата: не засчитана": "online payment: not credited",
 "отчёт Kaspi": "Kaspi report",
 "вручную": "manual",
 "таблица": "spreadsheet",
 "приёмка": "intake",
 "Документы": "Documents",
 "Политика конфиденциальности": "Privacy policy",
 "Возврат средств": "Refunds",
 "ИИН": "IIN",
 "Тел.:": "Tel.:",
 "Режим работы": "Working hours",
 "выдача посылок": "parcel pickup",
 "Выдача посылок": "Parcel pickup",
 "с 9:00 до 20:00": "9:00 to 20:00",
 "круглосуточно": "24/7",
 "Оплата банковскими картами Visa и Mastercard, Apple Pay и Google Pay через платёжный шлюз Freedom Pay. Мы не храним данные банковских карт.": "Payment by Visa and Mastercard cards, Apple Pay and Google Pay via the Freedom Pay payment gateway. We do not store bank card data.",
 "На главную": "To home page",
 "Адрес": "Address",
 "Реквизиты": "Details",
 "Реквизиты исполнителя": "Contractor details",
 "Торговая марка": "Trademark",
 "Другие города": "Other cities",
 "Темиртау": "Temirtau",
 "Астана": "Astana",
 "Принимаем к оплате": "We accept",
 "Запрещённые товары": "Prohibited items",
 "⛔ Запрещённые и хрупкие товары": "⛔ Prohibited and fragile items",
 "Открыть полный список →": "Open the full list →",
 "🎬 Видеоинструкции": "🎬 Video guides",
 "Видеоинструкции": "Video guides",
 "Не удалось загрузить видеоинструкции": "Could not load video guides",
 "Сохранено": "Saved",
 "Название и ссылка (например, на YouTube). Показываются клиентам в боте (/video) и на странице «Условия».": "Title and link (for example, YouTube). Shown to clients in the bot (/video) and on the Terms page.",
 "Название": "Title",
 "Ссылка": "Link",
 "+ Добавить видео": "+ Add video",
 "Сохранить видеоинструкции": "Save video guides",
 "📲 Подключите Telegram": "📲 Connect Telegram",
 "Уведомления о посылках и счетах, список посылок и добавление треков прямо в чате.": "Notifications about parcels and invoices, your parcel list and adding tracks right in the chat.",
 "Подключить": "Connect",
 "Позже": "Later",
 "Коды клиентов": "Client codes",
 "Не удалось загрузить коды клиентов": "Could not load client codes",
 "Не удалось выдать код": "Could not issue the code",
 "Сообщение скопировано": "Message copied",
 "Не удалось скопировать": "Could not copy",
 "Выдайте клиенту код и номер телефона: зарегистрироваться можно только по этой паре. Отправьте код клиенту в личном сообщении (WhatsApp или Telegram).": "Issue a code for the client's phone number: registration is possible only with this pair. Send the code to the client in a private message (WhatsApp or Telegram).",
 "Номер телефона клиента": "Client phone number",
 "Код клиента (латиницей)": "Client code (Latin letters)",
 "Выдать код": "Issue code",
 "Код выдан": "Code issued",
 "Скопировать сообщение клиенту": "Copy message for the client",
 "Выданные коды": "Issued codes",
 "Кодов пока нет": "No codes yet",
 "Выдал": "Issued by",
 "Скопировать": "Copy",
 "Ожидает регистрации": "Waiting for registration",
 "Зарегистрирован": "Registered",
 "Срок истёк": "Expired",
 "Адрес для этого филиала не задан: заполните его в «Мой карго» → Настройки филиала": "No address is set for this branch: fill it in “My cargo” → branch settings",
 "Адрес пока не задан, уточните его у менеджера": "The address is not set yet, please ask the manager",
 "Как адрес выглядит в приложении": "How the address looks in the app",
 "В приложении китайского маркетплейса добавьте адрес склада и в конце «Детального адреса» впишите свой код клиента (на примере он показан как «КОД КЛИЕНТА»). Адрес на примере для Темиртау; для вашего филиала скопируйте адрес выше.": "In the Chinese marketplace app, add the warehouse address and write your client code at the end of the “Detailed address” (shown as “КОД КЛИЕНТА” in the example). The example is for Temirtau; copy the address above for your branch.",
 "Заполнение адреса: в конце детального адреса стоит код клиента": "Filling in the address: the client code is at the end of the detailed address",
 "Сохранённый адрес с кодом клиента": "Saved address with the client code",
 "1. Вставьте адрес и допишите в конце свой код клиента": "1. Paste the address and add your client code at the end",
 "2. Сохранённый адрес: код клиента стоит в конце": "2. Saved address: the client code is at the end",
 "В приложении китайского маркетплейса добавьте адрес склада и в конце «Детального адреса» впишите свой код клиента.": "In the Chinese marketplace app, add the warehouse address and write your client code at the end of the “Detailed address”.",
 "Адрес вашего филиала в приложении": "Your branch address in the app",
 "в конце адреса стоит код клиента": "the client code goes at the end of the address",
 "Теперь это сотрудник филиала": "This user is now a branch employee",
 "Возвращён в клиенты": "Returned to clients",
 "Не удалось изменить роль": "Could not change the role",
 "сотрудник филиала": "branch employee",
 "Филиал сотрудника": "Employee branch",
 "Сделать сотрудником филиала": "Make a branch employee",
 "Вернуть в клиенты": "Return to clients",
 "Забыли пароль?": "Forgot password?",
 "Через Telegram": "Via Telegram",
 "Бот пришлёт кнопку со ссылкой. Она действует 15 минут и сработает один раз: откройте её и задайте новый пароль.": "The bot will send a button with a link. It works once and expires in 15 minutes: open it and set a new password.",
 "Открыть бот в Telegram": "Open the bot in Telegram",
 "Без Telegram": "Without Telegram",
 "Обратитесь к представителю своего филиала: он отправит вам ссылку для смены пароля в личном сообщении.": "Contact your branch representative: they will send you a password reset link in a private message.",
 "← Вернуться ко входу": "← Back to sign in",
 "Новый пароль": "New password",
 "Проверяем ссылку...": "Checking the link...",
 "Как восстановить пароль": "How to recover your password",
 "Пароли не совпадают": "Passwords do not match",
 "Не удалось сменить пароль": "Could not change the password",
 "Повторите пароль": "Repeat the password",
 "Сменить пароль": "Change password",
 "Пароль изменён. Теперь можно войти с новым паролем.": "Password changed. You can now sign in with the new password.",
 "Отправить ссылку для смены пароля": "Send password reset link",
 "Не удалось создать ссылку": "Could not create the link",
 "Ссылка отправлена клиенту в Telegram.": "The link was sent to the client in Telegram.",
 "У клиента не подключён Telegram: скопируйте сообщение и отправьте ему в WhatsApp.": "The client has no Telegram linked: copy the message and send it via WhatsApp.",
 "Ссылка действует 15 минут и сработает один раз.": "The link works once and expires in 15 minutes.",
 "Нажмите кнопку «Открыть бот в Telegram» ниже и в Telegram нажмите «Старт». Если бот уже открыт, нажмите в его меню кнопку «🔑 Забыл пароль».": "Tap “Open the bot in Telegram” below and press “Start” in Telegram. If the bot is already open, tap “🔑 Forgot password” in its menu.",
 "Ссылка недействительна или устарела. Запросите новую: в боте нажмите «🔑 Забыл пароль» или попросите представителя филиала.": "The link is invalid or has expired. Request a new one: tap “🔑 Forgot password” in the bot or ask your branch representative.",
 "Если бот ещё не подключён к вашему аккаунту, поделитесь контактом кнопкой в чате: так мы убеждаемся, что номер ваш.": "If the bot is not yet linked to your account, share your contact with the button in the chat: this is how we make sure the number is yours.",
 "Заявки": "Requests",
 "Не удалось загрузить заявки": "Failed to load requests",
 "Заявки на обрешётку и инспекцию, которые клиенты отправили через Telegram-бота до поступления товара на склад. Новые заявки приходят и сообщением в Telegram представителю филиала.": "Crating and inspection requests that clients sent via the Telegram bot before the goods arrive at the warehouse. New requests are also sent to the branch representative in Telegram.",
 "Новых заявок": "New requests",
 "Только новые": "New only",
 "Заявок нет": "No requests",
 "Услуга": "Service",
 "Обрешётка": "Crating",
 "Инспекция": "Inspection",
 "Обрешётка + инспекция": "Crating + inspection",
 "Новая": "New",
 "Выполнена": "Done",
 "Отменена": "Cancelled",
 "Выполнено": "Done",
 "Вернуть в новые": "Back to new",
 "Привет! Закажи доставку из Китая в 291cargo. При регистрации укажи мой номер": "Hi! Order delivery from China with 291cargo. When registering, enter my number",
 "Приглашение скопировано": "Invitation copied",
 "Реферальная программа": "Referral program",
 "Сейчас программа недоступна для вашего филиала.": "The program is not available for your branch right now.",
 "Ваша скидка на вес": "Your weight discount",
 "Активных приглашённых": "Active referrals",
 "У вас личный (VIP) тариф: реферальная скидка с ним не суммируется.": "You have a personal (VIP) rate: the referral discount does not apply with it.",
 "Скидка начисляется на плату за вес при выставлении счёта. Процент фиксируется в момент выставления счёта.": "The discount applies to the weight charge when an invoice is issued. The percentage is fixed at the moment of invoicing.",
 "Как это работает": "How it works",
 "Дайте новому клиенту свой номер телефона": "Give the new client your phone number",
 "При регистрации он вводит ваш номер в поле «Номер пригласившего».": "When registering, they enter your number in the “Referrer phone” field.",
 "Каждый приглашённый, у которого за последние {{v0}} дн. не меньше {{v1}} посылок на складе, даёт вам {{v2}}% скидки (максимум {{v3}}%).": "Each referral with at least {{v1}} parcels at the warehouse in the last {{v0}} days gives you {{v2}}% discount (up to {{v3}}%).",
 "Пригласить друга": "Invite a friend",
 "Привязать можно только нового клиента при его регистрации. Себя и уже зарегистрированных указать нельзя.": "Only a new client can be linked, at registration. You cannot enter yourself or already registered clients.",
 "Ваши приглашённые": "Your referrals",
 "Пока никого нет": "No one yet",
 "Посылок за {{v0}} дн.": "Parcels in {{v0}} days",
 "Активен": "Active",
 "Не активен": "Inactive",
 "Не удалось загрузить настройки": "Failed to load settings",
 "Клиент приводит новых клиентов (они указывают его номер при регистрации) и получает скидку на вес. Приглашённый активен, если за период у него не меньше заданного числа посылок, прибывших на склад. С личным (VIP) тарифом скидка не действует.": "A client brings new clients (they enter the client’s number at registration) and gets a weight discount. A referral is active if during the period they have at least the set number of parcels that arrived at the warehouse. The discount does not apply with a personal (VIP) rate.",
 "Программа включена": "Program enabled",
 "Процент за одного активного, %": "Percent per active referral, %",
 "Максимальная скидка, %": "Maximum discount, %",
 "Минимум посылок у приглашённого": "Minimum parcels per referral",
 "Период активности, дней": "Activity period, days",
 "Программа действует для клиентов только тех филиалов, где она включена.": "The program applies only to clients of branches where it is enabled.",
 "Кто сколько привёл": "Who referred how many",
 "Приведено": "Referred",
 "Активных": "Active",
 "Скидка": "Discount",
 "выкл.": "off",
 "VIP-тариф": "VIP rate",
 "Адрес склада сохранён": "Warehouse address saved",
 "Адрес склада филиала": "Branch warehouse address",
 "Этот адрес видит клиент в разделе «Склад», он же копируется кнопкой «Скопировать адрес склада». Вместо кода клиента пишите «КОД КЛИЕНТА» — подставится автоматически.": "Clients see this address in the “Warehouse” section, and it is what the “Copy warehouse address” button copies. Write “КОД КЛИЕНТА” instead of the client code — it is filled in automatically.",
 "Адрес не задан — клиентам показывается общий адрес": "Not set — clients see the general address",
 "Сохранить адрес": "Save address",
 "Тарифы, реквизиты и история": "Rates, details and history"
};

export default dict;
